import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { QrCode as QrIcon, Download, Printer } from "lucide-react";

// High-res QR for print + on-screen preview. Encodes the public menu URL.
export const QrCodeSection = ({ restaurantName, subtitle }) => {
  const previewRef = useRef(null);
  const [dataUrl, setDataUrl] = useState("");
  const url = typeof window !== "undefined" ? window.location.origin : "";

  useEffect(() => {
    if (!url) return;
    // On-screen preview
    if (previewRef.current) {
      QRCode.toCanvas(previewRef.current, url, {
        width: 220,
        margin: 2,
        color: { dark: "#060A14", light: "#FDFBF7" },
      });
    }
    // High-res version for download/print
    QRCode.toDataURL(url, {
      width: 1200,
      margin: 2,
      errorCorrectionLevel: "H",
      color: { dark: "#060A14", light: "#FDFBF7" },
    }).then(setDataUrl);
  }, [url]);

  const download = () => {
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = "qr-menu-giardino-del-gusto.png";
    a.click();
  };

  const printCard = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>QR Menu — ${restaurantName}</title>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700&family=Manrope:wght@400;600&display=swap');
        html,body{margin:0;height:100%;}
        body{background:#060A14;color:#FDFBF7;display:flex;align-items:center;justify-content:center;font-family:Manrope,sans-serif;}
        .card{text-align:center;padding:48px 40px;border:2px solid #D4AF37;border-radius:14px;max-width:520px;}
        .sub{letter-spacing:.35em;text-transform:uppercase;font-size:13px;color:#D4AF37;margin-bottom:6px;}
        h1{font-family:'Cormorant Garamond',serif;color:#D4AF37;font-size:44px;margin:0 0 4px;}
        .qr{margin:26px auto;width:300px;height:300px;background:#FDFBF7;border-radius:10px;padding:14px;box-sizing:border-box;}
        .qr img{width:100%;height:100%;}
        .cta{font-family:'Cormorant Garamond',serif;font-size:26px;color:#FDFBF7;margin-top:8px;}
        .hint{font-size:13px;color:#E0DDCF;opacity:.8;margin-top:6px;}
      </style></head>
      <body onload="setTimeout(function(){window.print()},400)">
        <div class="card">
          <div class="sub">${subtitle || ""}</div>
          <h1>${restaurantName}</h1>
          <div class="qr"><img src="${dataUrl}"/></div>
          <div class="cta">Inquadra per il menu</div>
          <div class="hint">Punta la fotocamera del telefono sul codice</div>
        </div>
      </body></html>`);
    w.document.close();
  };

  return (
    <div className="bg-[#0f172a] border border-[#d4af37]/20 rounded-md p-5">
      <h3 className="font-serif text-2xl text-[#d4af37] flex items-center gap-2 mb-2">
        <QrIcon className="w-5 h-5" /> QR Code per i tavoli
      </h3>
      <p className="text-xs text-[#e0ddcf]/70 mb-4">
        Scarica o stampa il QR: i clienti lo inquadrano e vedono subito il menu.
        Il codice punta sempre a questa pagina, quindi resta valido anche quando
        aggiorni il menu.
      </p>
      <div className="flex flex-col items-center gap-4">
        <div className="bg-[#FDFBF7] p-3 rounded-md">
          <canvas ref={previewRef} data-testid="qr-preview" />
        </div>
        <p className="text-[11px] text-[#e0ddcf]/50 break-all text-center">
          {url}
        </p>
        <div className="w-full flex flex-col gap-3">
          <button
            onClick={download}
            disabled={!dataUrl}
            data-testid="download-qr-button"
            className="w-full bg-[#d4af37] text-[#060a14] font-semibold px-4 py-2.5 rounded-sm active:scale-95 transition-transform flex items-center justify-center gap-2 disabled:opacity-50 text-sm"
          >
            <Download className="w-4 h-4" /> Scarica QR (PNG)
          </button>
          <button
            onClick={printCard}
            disabled={!dataUrl}
            data-testid="print-qr-button"
            className="w-full bg-transparent border border-[#d4af37] text-[#d4af37] px-4 py-2.5 rounded-sm hover:bg-[#d4af37]/10 active:bg-[#d4af37]/20 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 text-sm font-medium"
          >
            <Printer className="w-4 h-4" /> Stampa scheda tavolo
          </button>
        </div>
      </div>
    </div>
  );
};

export default QrCodeSection;
